/* eslint-disable react/style-prop-object */
import React from 'react';
import Button from 'shared/components/Buttons/Button';

const PrimaryButton = props => <Button {...props} variant="primary" />;

export default PrimaryButton;
